import { CloseOutlined, RightOutlined } from '@ant-design/icons';
import IconRound from 'assets/logos/icon-round.svg?react';
import ModuleCard from 'components/cards/ModuleCard';
import { Button } from 'components/ui/button';
import usePreferences from 'hooks/usePreferences';
import posthog from 'posthog-js';
import Keys from 'preferences/preferences';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { routes } from 'services/RouteService';

// Placeholder article id — to be swapped for the real announcement post once it's published.
const REBRANDING_ARTICLE_ID = '109';

export default function RebrandingAnnouncementCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { value: dismissed, set: dismiss, loading } = usePreferences(Keys.HOME_REBRANDING_ANNOUNCEMENT_DISMISSED);

  const shouldDisplay = !loading && dismissed !== true;
  if (!shouldDisplay) return null;

  const navigateToArticle = () => {
    posthog.capture('home.rebranding_announcement_clicked');
    dismiss('true');
    navigate(routes.article.route.replace(':index', REBRANDING_ARTICLE_ID));
  };
  const handleKeyDown = (e: React.KeyboardEvent) => e.key === 'Enter' && navigateToArticle();

  return (
    <ModuleCard accentBackground onClick={navigateToArticle} role="button" tabIndex={0} onKeyDown={handleKeyDown}>
      <div className="flex items-start gap-2">
        <div className="flex min-w-0 flex-1 items-center gap-3.5">
          <div className="text-primary-foreground flex size-11 shrink-0 items-center justify-center rounded-full bg-white/25">
            <IconRound fill="currentColor" width={22} height={22} />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-primary-foreground m-0 text-base leading-snug font-bold">{t('home.rebranding.title')}</p>
            <p className="text-primary-foreground mt-0.5 mb-0 text-xs leading-snug">
              {t('home.rebranding.subtitle')}
              {/* A non-breaking space, so the caret can't wrap onto a line of its own — it stays glued to the last word. */}{' '}
              <RightOutlined className="text-primary-foreground text-sm" />
            </p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="text-primary-foreground shrink-0 hover:bg-white/25"
          aria-label={t('home.rebranding.dismiss')}
          onClick={e => {
            e.stopPropagation();
            dismiss('true');
          }}
        >
          <CloseOutlined />
        </Button>
      </div>
    </ModuleCard>
  );
}
